export type BaseModel = {
  ID: string,
  createdAt?: Date,
  createdBy?: number,
  updatedAt?: Date,
  updatedBy?: number,
  deletedAt?: Date | null,
  deletedBy?: number | null,
  status?: number
}

export const STATUS = {
  ACTIVE: 1,
  PENDING: 2
}